export const customElement = () => import('@webcomponents/custom-elements');

// copied from https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
export const customEvent = () => {
    if ( typeof window.CustomEvent === "function" ) return Promise.resolve();

    function CustomEvent ( event, params ) {
        params = params || { bubbles: false, cancelable: false, detail: null };
        var evt = document.createEvent( 'CustomEvent' );
        evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
        return evt;
    }

    window.CustomEvent = CustomEvent;

    return Promise.resolve();
}